import {useContext} from 'react';
import {Web3Context} from '../providers';

export const useWeb3Connect = () => {
  const context = useContext(Web3Context);

  if (!context) {
    throw new Error(
      'Missing the Web3Connect integration. Please make sure you have added it to your project.'
    );
  }

  return context;
};
